var n, i;
function l() {
  if (i)
    return n;
  i = 1;
  var a = function(o, r, t, u, s, f, d, v) {
    if (process.env.NODE_ENV !== "production" && r === void 0)
      throw new Error("invariant requires an error message argument");
    if (!o) {
      var e;
      if (r === void 0)
        e = new Error(
          "Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings."
        );
      else {
        var c = [t, u, s, f, d, v], w = 0;
        e = new Error(
          r.replace(/%s/g, function() {
            return c[w++];
          })
        ), e.name = "Invariant Violation";
      }
      throw e.framesToPop = 1, e;
    }
  };
  return n = a, n;
}
export {
  l as __require
};
//# sourceMappingURL=browser.js.map
